import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { EnableFor } from '../../../../../../../containers/EnableForRole';
import { useProjectDetailsPermissions } from '../../../../../projectDetails.permissions';
import { FilterTabType } from '../../../imageFilters.model';
import { FilterHeader } from '../FilterHeader';
import { ImageFiltersFormProps } from '../ImageFiltersForm';

export const ReviewedByHeader = observer((props: ImageFiltersFormProps): ReactElement => {
  const permissions = useProjectDetailsPermissions();
  const canSeeUsers = permissions.canSeeAnnotationAuthors();

  const handleClear = (): void => {
    props.onSetReviewedBy([]);
  };

  const isSelected = props.activeFilterType === FilterTabType.ReviewedBy;
  const count = props.imageFilters.reviewedBy.length;

  return (
    <EnableFor hasPermission={canSeeUsers}>
      <FilterHeader
        filterType={FilterTabType.ReviewedBy}
        isSelected={isSelected}
        labelKey='reviewed_by'
        count={count}
        showClear={count > 0}
        onClear={handleClear}
        onSelect={props.onFilterTabSelect}
      />
    </EnableFor>
  );
});
